import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import styles from './AddGoal.module.scss';
import SaveGoalForm from './SaveGoalForm';
import LimitGoalForm from './LimitGoalForm.jsx';
import IncomeGoalForm from './IncomeGoalForm.jsx';
import CloseCircle from '../../assets/icons/Close_Circle.svg';
import UniversalModal from '../UniversalModal/UniversalModal';

const TABS = [
  { id: 'save', label: 'Накопить' },
  { id: 'income', label: 'Доход' },
  { id: 'limit', label: 'Лимит' },
];

const FADE_MS = 300;

const makeInitialDraftSave = () => ({
  title: '',
  target_amount: '',
  start_amount: '',
  deadline: '',
  comment: '',
  product_url: '',
  image_url: '',
});
const makeInitialDraftIncome = () => ({
  title: '',
  target_amount: '',
  deadline: '',
  comment: '',
});
const makeInitialDraftLimit = () => ({
  title: '',
  limit_amount: '',
  category_id: '',
  period: 'day',
  comment: '',
});

const AddGoal = ({ onCreated, renderTrigger }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [activeTab, setActiveTab] = useState('save');
  const [pendingTab, setPendingTab] = useState('save');
  const [anim, setAnim] = useState('in');

  const [draftSave, setDraftSave] = useState(() => makeInitialDraftSave());
  const [draftIncome, setDraftIncome] = useState(() =>
    makeInitialDraftIncome()
  );
  const [draftLimit, setDraftLimit] = useState(() => makeInitialDraftLimit());

  const pendingIndex = useMemo(
    () => TABS.findIndex((t) => t.id === pendingTab),
    [pendingTab]
  );

  const resetDrafts = () => {
    setDraftSave(makeInitialDraftSave());
    setDraftIncome(makeInitialDraftIncome());
    setDraftLimit(makeInitialDraftLimit());
  };

  const openModal = () => {
    resetDrafts();
    setActiveTab('save');
    setPendingTab('save');
    setAnim('in');
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const renderForm = () => {
    if (activeTab === 'save')
      return <SaveGoalForm value={draftSave} onChange={setDraftSave} />;
    if (activeTab === 'income')
      return <IncomeGoalForm value={draftIncome} onChange={setDraftIncome} />;
    return <LimitGoalForm value={draftLimit} onChange={setDraftLimit} />;
  };

  const switchTab = (nextId) => {
    if (nextId === pendingTab) return;
    setPendingTab(nextId);
    setAnim('out');
    setTimeout(() => {
      setActiveTab(nextId);
      setAnim('in');
    }, FADE_MS);
  };

  async function handleCreate() {}

  const bodyContentRef = useRef(null);

  useLayoutEffect(() => {
    const content = bodyContentRef.current;
    if (!content) return;
    const set = () => setBodyH(content.scrollHeight);
    set();
    const ro = new ResizeObserver(() => set());
    ro.observe(content);
    return () => ro.disconnect();
  }, [activeTab, isOpen]);

  return (
    <>
      {renderTrigger ? (
        renderTrigger(openModal)
      ) : (
        <button
          type='button'
          className={styles.openModalBtn}
          onClick={openModal}
          data-add-goal-btn='true'>
          <img src={CloseCircle} alt='' className={styles.modal__icon} />
          Новая цель
        </button>
      )}

      <UniversalModal isOpen={isOpen} onClose={closeModal} title='Новая цель:'>
        <div className={styles.goals__tabs}>
          <div
            className={styles.goal__tabIndicator}
            style={{ transform: `translateX(${pendingIndex * 100}%)` }}
          />
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type='button'
              onClick={() => switchTab(tab.id)}
              className={[
                styles.goal__tab,
                pendingTab === tab.id ? styles.goal__tabActive : '',
              ].join(' ')}>
              {tab.label}
            </button>
          ))}
        </div>

        <div
          className={[
            styles.goals__body,
            anim === 'out' ? styles.bodyOut : styles.bodyIn,
          ].join(' ')}>
          {renderForm()}
        </div>

        <div className={styles.goals__footer}>
          <button
            type='button'
            className={styles.goals__btn}
            onClick={closeModal}>
            Отмена
          </button>
          <button
            type='button'
            className={styles.goals__btn}
            onClick={handleCreate}>
            Создать
          </button>
        </div>
      </UniversalModal>
    </>
  );
};

export default AddGoal;
